export function Card({ className = "", children, ...props }) {
  return (
    <div className={["rounded-md bg-white", className].filter(Boolean).join(" ")} {...props}>
      {children}
    </div>
  );
}

export function CardContent({ className = "", children, ...props }) {
  return (
    <div className={["p-4", className].filter(Boolean).join(" ")} {...props}>
      {children}
    </div>
  );
}
